module.exports = __webpack_public_path__ + "img/reference.3a62d309.svg";